import { type ListingCardView } from '@/features/listing/types/listing-types';

interface AppConfig {
  isMobileAuthEnabled: boolean;
  defaultListingCardView: ListingCardView;
  loginLink: string;
}

const APP_CONFIG: AppConfig = {
  defaultListingCardView: 'grid',
  isMobileAuthEnabled: process.env.NEXT_PUBLIC_IS_MOBILE_AUTH_ENABLED === 'true',
  loginLink: '/phone-auth',
};

export default APP_CONFIG;
